import { Card, makeStyles, Text, tokens } from "@fluentui/react-components";
import { ArrowUpRegular, ArrowDownRegular, SubtractRegular } from "@fluentui/react-icons";
import type React from "react";

export interface KpiItem {
  label: string;
  value: string | number;
  subtitle?: string;
  status?: "good" | "warning" | "critical";
  trend?: string;
  trendDirection?: "up" | "down" | "neutral";
}

const statusColor = (s?: KpiItem["status"]) =>
  s === "good" ? tokens.colorPaletteGreenForeground1
  : s === "warning" ? tokens.colorPaletteYellowForeground2
  : s === "critical" ? tokens.colorPaletteRedForeground1
  : tokens.colorNeutralForeground1;

const useStyles = makeStyles({
  strip: { display: "flex", flexWrap: "wrap", gap: tokens.spacingHorizontalM },
  card: { display: "flex", flexDirection: "column", gap: tokens.spacingVerticalXS, padding: tokens.spacingVerticalM, minWidth: "10rem", flex: "1 1 10rem" },
  value: { fontVariantNumeric: "tabular-nums" },
  trend: { display: "flex", alignItems: "center", gap: tokens.spacingHorizontalXS, color: tokens.colorNeutralForeground3 },
});

export function KpiStrip({ items }: { items: KpiItem[] }): React.JSX.Element {
  const s = useStyles();
  return (
    <div className={s.strip}>
      {items.map((item) => (
        <Card key={item.label} className={s.card}>
          <Text size={200} style={{ color: tokens.colorNeutralForeground2 }}>{item.label}</Text>
          <Text size={600} weight="semibold" className={s.value} style={{ color: statusColor(item.status) }}>
            {item.value}
          </Text>
          {item.subtitle && <Text size={200} style={{ color: tokens.colorNeutralForeground3 }}>{item.subtitle}</Text>}
          {item.trend && (
            <div className={s.trend}>
              {item.trendDirection === "up" ? <ArrowUpRegular fontSize={12} /> : item.trendDirection === "down" ? <ArrowDownRegular fontSize={12} /> : <SubtractRegular fontSize={12} />}
              <Text size={100}>{item.trend}</Text>
            </div>
          )}
        </Card>
      ))}
    </div>
  );
}
